<script>
    let textToDisplay = "";

    function selectText() {
        const random = Math.random();
        textToDisplay = random < 0.6 ? "你是小楠酿" : "你不是小楠酿";
    }

    selectText();
</script>

<main>
    <div class="card">
        <h1>{textToDisplay}</h1>
    </div>
</main>

<style global>
    :global(body) {
        margin: 0;
        background: linear-gradient(135deg, #ff9de2 0%, #9d6bff 100%);
        min-height: 100vh;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    }

    .card {
        background: rgba(255, 255, 255, 0.95);
        padding: 3rem 5rem;
        border-radius: 20px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(10px);
        text-align: center;
        animation: fadeIn 0.6s ease-out;
    }

    h1 {
        font-size: 4rem;
        margin: 0;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
        background: linear-gradient(45deg, #ff3b9d, #ff6b6b);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    main {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
        padding: 2rem;
    }

    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
    }
</style>
